import React, { Component } from 'react';
import BlitzAPI from '../../api/BlitzAPI';

function StatItem(props) {
  const { caption, data, title} = props;

  const formattedData = data && data < 1 ? `${(data * 100).toPrecision(2)}%` : data;


  return (
    <div className="dashboard-stat-item ">
      <h3>{title}</h3>
      <div className="dashboard-stat-content clearfix">
        <h4 className="dashboard-stat-number">{formattedData}</h4>
      </div>
      <p className="dashboard-stat-caption">{caption}</p>
    </div>
  );
}

export default class AppTrackingDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    };
  }

  componentDidMount() {
    BlitzAPI.getStatsOverview().then(resp => this.setState({ data: resp.data }));
  }

  render() {
    const { data } = this.state;

    return (
      <div className="dashboard">
        <h1>Tracking Dashboard</h1>
        <h2 className="page-title dashboard-title">Last Week Stats</h2>
        {data &&
          <div className="dashboard-stat clearfix">
            <StatItem
              title="Last Week Average Ratio"
              data={data.last_week_average_ratio}
              caption="Average ratio of all users last week."
            />
            <StatItem
              title="Last Week Tracked Once Ratio"
              data={data.last_week_tracked_once_ratio}
              caption="Ratio of all users who have been tracked at least once (used the app once) in the last week."
            />
            <StatItem
              title="Last Week Failed to Onboard"
              data={data.last_week_never_tracked_percent}
              caption="% of users who installed app, but never tracked."
            />
            <StatItem
              title="Last Week New Users"
              data={data.last_week_new_users}
              caption="New Users last week"
            />
            <StatItem
              title="Last Week Games Played"
              data={data.last_week_games_played}
              caption="Games played with the Blitz App last week"
            />
          </div>
        }
        <h2 className="page-title dashboard-title">Overall Stats</h2>
        {data &&
          <div className="dashboard-stat clearfix">
            <StatItem
              title="Overall Ratio"
              data={data.overall_ratio}
              caption="Average ratio of all users."
            />
            <StatItem
              title="Tracked Once Ratio"
              data={data.tracked_once_ratio}
              caption="Average ratio of all users who have tracked at least 1 time."
            />
            <StatItem
              title="Never Tracked Ratio"
              data={data.never_tracked_percent}
              caption="Ratio of all Users who failed to onboard (Track 1 game)"
            />
            <StatItem
              title="Total users tracked"
              data={data.total_tracked_users}
              caption="Total Users who have tracked at least once"
            />
            <StatItem
              title="Games played with Blitz"
              data={data.total_games_played}
              caption="Total games played by people using the Blitz App! (Recent to 7 days ago)"
            />
          </div>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/cms/tracking/AppTrackingDashboard.js